module.exports = __webpack_public_path__ + "img/img048.d6d46182.png";